var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(!_vm.isHome)?_c('Header'):_vm._e(),(!_vm.isHome)?_c('v-main',[_c('router-view')],1):_vm._e(),(_vm.isHome)?_c('router-view'):_vm._e(),_c('vue-progress-bar'),(!_vm.isHome)?_c('Footer'):_vm._e(),_c('vue-progress-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }